import { render, staticRenderFns } from "./ed-portal-tools.component.vue?vue&type=template&id=3846de10&scoped=true&"
import script from "./ed-portal-tools.component.ts?vue&type=script&lang=ts&"
export * from "./ed-portal-tools.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-portal-tools.component.scss?vue&type=style&index=0&id=3846de10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846de10",
  null
  
)

export default component.exports